module.exports = __webpack_public_path__ + "images/frontpage_sizes@2x.png?86dad90c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_sizes@2x.png
// module id = 661
// module chunks = 7